import OrgAdminSalesCoachMain from "@/features/salesCoach/components/OrgAdminSalesCoachMain";
import React from "react";

const OrgAdminSalesCoach = () => {
  return <OrgAdminSalesCoachMain />;
};

export default OrgAdminSalesCoach;
